export type CatTownEventMap = {
  "plot:selected": { plotId: string };
  "plot:updated": { plotId: string };
  "cat:selected": { catId: string };
  "cat:fed": { catId: string };
  "cat:petted": { catId: string };
  "cat:owned": { catId: string };
  "player:created": Record<string, never>;
  "player:action": { action: "plant" | "water" | "harvest" | "feed" | "pet" | "happy"; targetX?: number; targetY?: number };
  "decoration:place-start": { type: string; existingId?: string };
  "decoration:place-cancel": Record<string, never>;
  "decoration:selected": { decorationId: string };
  "decoration:updated": Record<string, never>;
  "scene:ready": Record<string, never>;
  "toast": { message: string; tone?: "success" | "warning" | "info" };
};

export class GameEventBus extends EventTarget {
  emit<K extends keyof CatTownEventMap>(name: K, detail: CatTownEventMap[K]): void {
    this.dispatchEvent(new CustomEvent(name, { detail }));
  }

  on<K extends keyof CatTownEventMap>(
    name: K,
    handler: (detail: CatTownEventMap[K]) => void,
  ): () => void {
    const listener = (event: Event) => handler((event as CustomEvent<CatTownEventMap[K]>).detail);
    this.addEventListener(name, listener);
    return () => this.removeEventListener(name, listener);
  }
}

export const gameEvents = new GameEventBus();
